export default __webpack_public_path__ + "static/media/whatcard3.06ef90de.svg";